// extracted by mini-css-extract-plugin
export default {"flipButton":"FlipButton_flipButton__+l8Sx","invert":"FlipButton_invert__0wywy"};